$(document).ready(function () {

    $(document).on('click', '.klaviyo-close-form', function () {
        setTimeout(function () {
            $('[aria-label="POPUP Form"]').remove();
        }, 1000);
    })

    $('.goh-faq .goh-bottom .item h5').click(function () {
        $('.goh-faq .goh-bottom .item .content.open').removeClass('open');
        if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $(this).next('.content').removeClass('open');
        } else {
            $('.goh-faq .goh-bottom .item h5').removeClass('open');
            $(this).addClass('open');
            $(this).next('.content').addClass('open');
        }
    });

    if ($('.product__slider-main').length) {
        var dot = false;
        if ($('.product__slider-main .one-by-one').length == 1) {
            dot = false;
        }
        var $slider = $('.product__slider-main')
            .on('init', function (slick) {
                $('.product__slider-main').fadeIn(1000);
                //clrbx();
            })
            .slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                lazyLoad: 'ondemand',
                autoplaySpeed: 3000,
                dots: dot,
                swipe: false,
                asNavFor: '.product__slider-thumb'
            });

        var thumbnailsSlider = $('.product__slider-thumb')
            .on('init', function (slick) {
                $('.product__slider-thmb').fadeIn(1000);
            })
            .slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                lazyLoad: 'ondemand',
                asNavFor: '.product__slider-main',
                arrows: true,
                infinity: false,
                dots: false,
                centerMode: false,
                focusOnSelect: true,

            });

        //     //remove active class from all thumbnail slides
        //     $('.product__slider-thmb .slick-slide').removeClass('slick-active');

        //     //set active class to first thumbnail slides
        //     $('.product__slider-thmb .slick-slide').eq(0).addClass('slick-active');

        //     // On before slide change match active thumbnail to current slide
        //     $('.product__slider-main').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        //       var mySlideNumber = nextSlide;
        //       $('.product__slider-thmb .slick-slide').removeClass('slick-active');
        //       $('.product__slider-thmb .slick-slide').eq(mySlideNumber).addClass('slick-active');
        //     });

        // init slider
        //require(['js-sliderWithProgressbar'], function(slider) {
        $('.product__slider-main').each(function () {
            //var sldr = new slider($(this), options, sliderOptions, previewSliderOptions);
        });
        //});

        var options = {
            progressbarSelector: '.bJS_progressbar'
            , slideSelector: '.bJS_slider'
            , previewSlideSelector: '.bJS_previewSlider'
            , progressInterval: ''
            , onCustomProgressbar: function ($slide, $progressbar) { }
        }

        var sliderOptions = {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            autoplay: true
        }

        var previewSliderOptions = {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            focusOnSelect: true,
            centerMode: true
        }

        // Colorbox
        function clrbx() {
            /*var $slides = $('.product__slider--lghtbox .slide img');
          console.log($slides);
          $('.product__slider--lghtbox .slide img').colorbox({
            rel: 'cboxElement',
          });*/


            $('.product__slider-main .slick-slide').each(function () {

            });

            //$('.product__slider-main .slick-slide').each()
        }
        setTimeout(function () {
            var sliderHeight = $('.template-product #ProductPhoto .slick-slider.product__slider-main .slick-list').outerHeight();
            $('.template-product #ProductPhoto .product__slider-thumb').css('min-height', sliderHeight + 'px !important')
            console.log('sliderHeigh2t', sliderHeight)
        }, 10000)
    }

    $('.collection_pots .pot').click(function () {
        var url_image = $(this).find('label').attr('data-image');
        $('[data-id=change-image-1] div').css('background-image', 'url(' + url_image + ')');
        // $('html, body').animate({
        //   scrollTop: $(".product-row").offset().top
        // }, 500);
        $('#slick-slide-control00').click();
    })

    function waitForSearchanise() {
        const checkInterval = 100;
        const maxWaitTime = 20000;
        let elapsedTime = 0;

        const intervalId = setInterval(() => {
            if (typeof Searchanise !== 'undefined') {
                console.log('Searchanise is now available!');
                clearInterval(intervalId);
                onSearchaniseReady();
            } else {
                elapsedTime += checkInterval;
                if (elapsedTime >= maxWaitTime) {
                    console.log('Max wait time reached. Executing action...');
                    clearInterval(intervalId);
                    onMaxWaitTimeReached();
                }
            }
        }, checkInterval);
    }

    function onSearchaniseReady() {
        console.log('You can now use Searchanise!');
        setTimeout(function () {
            $('.site-header__search #FormSearch').addClass('is-active');
        }, 1000);
    }

    function onMaxWaitTimeReached() {
        console.log('Searchanise is still not available after 20 seconds. Please check your setup.');
        setTimeout(function () {
            $('.site-header__search #FormSearch').addClass('is-active');
        }, 1000);
    }

    waitForSearchanise();

    $('.site-header__search > a').click(function (event) {
        event.preventDefault();
        if (window.innerWidth < 816) {
            $(this).next('#FormSearch').slideToggle();
        }
    });

    if ($('#ContactForm').length) {
        $('#k_id_email').val($('#ContactForm input[name="contact[email]"]').val()).change();
        $('#ContactForm input[name="contact[email]"]').on('keydown keyup keypress blur change', function (evt) {
            $('#k_id_email').val($(this).val()).change();
        })
        $('#ContactForm input.fake-submit').on('click', function (evt) {
            if ($('#contact_form input[name="contact[subscribed]"]:checked').length) {
                $('#email_signup .klaviyo_submit_button').click();
            } else $('#ContactForm input[type="submit"]').click();
        })

        //     $("form#contact_form").submit(function(event) {
        //       var val = $('#ContactForm input[name="contact[email]"]').val();
        //       $('#shopify-section-index-subscribe-form form input[type="email"]').val(val);
        //       if( $('#ContactForm form label input[type="checkbox"]').is(':checked')){
        //         if($('#ContactForm form textarea:empty').val() != '' 
        //            && $('#ContactForm form input[name="contact[email]"]:empty').val() != ''
        //            && $('#ContactForm form input[name="contact[Name]"]:empty').val() != '') {
        // //           $('#shopify-section-index-subscribe-form form button[type="button"]').click();
        // //           $('#shopify-section-index-subscribe-form form button[type="button"]').trigger('click');
        //           $("#shopify-section-index-subscribe-form form").submit();
        // //           $('#shopify-section-index-subscribe-form form button.needsclick').click();
        // //           event.preventDefault();
        // //           setTimeout(function(){
        // //             $("form#contact_form").submit();
        // //           }, 10000);
        //         }
        //       }
        //     });


        //     var my_form = document.getElementById("contact_form");
        //     my_form.onsubmit = function() {
        //       return false;
        //     }

        //     $('#ContactForm input[type=submit]').click(function() {
        //       if( $('#ContactForm form label input[type="checkbox"]').is(':checked')){
        //         if($('#ContactForm form textarea:empty').val() != '' 
        //            && $('#ContactForm form input[name="contact[email]"]:empty').val() != ''
        //            && $('#ContactForm form input[name="contact[Name]"]:empty').val() != '') {
        //           $("#shopify-section-index-subscribe-form form").submit();
        //           setTimeout(function() {
        //             my_form.submit();
        //           }, 5000);
        //         }
        //       }
        //     });

        /*$('#ContactForm input[type=submit]').click(function(e) {
          e.preventDefault();
          console.log('asdsdaa');
          if( $('#ContactForm form label input[type="checkbox"]').is(':checked')){
            console.log('111111111');
            $("#shopify-section-index-subscribe-form form").submit();
          }
        });*/
    }

    var ratingScore = $('.jdgm-prev-badge').attr('data-average-rating');
    ratingScore = (Math.round(ratingScore * 10) / 10).toFixed(1)
    var rating = $('.jdgm-prev-badge__text').text();
    $('.template-product .jdgm-prev-badge__text').html('<span class="rating-score">' + ratingScore + ' stars</span>' + rating);

    movePostcode();

    function movePostcode() {
        if ($(window).width() < 768) {
            $('.product-form-container .product-content').after($('.delivery-postcode-wrapper'));
        }
        else {
            $('.product-form__item').last().after($('.delivery-postcode-wrapper'));
        }
    }

    $(window).on('resize', function () {
        movePostcode();
    })

    $('.product-form .quantity').on('keyup', function (e) {
        if ($(this).val() <= 0) {
            $('.product-form #AddToCart').attr('disabled', '');
        }
        else {
            $('.product-form #AddToCart').removeAttr('disabled');
        }
    })

    $('.plusOne').click(function () {
        $('.product-form #AddToCart').removeAttr('disabled');
        if ($('.product-form .quantity').val() < 0) {
            $('.product-form .quantity').val(1);

        }
    })

    $('.fancybox').fancybox({
        width: '1280',
        height: '720',
        scrolling: 'no',
        aspectRatio: true,
        type: 'iframe',
        beforeShow: function () {
            $("body").css({ 'overflow-y': 'hidden' });
        },
        afterClose: function () {
            $("body").css({ 'overflow-y': 'visible' });
        },
    });

    var count = 0;
    var countClick = 0;
    menuHover();
    function menuHover() {
        if ($(window).width() > 815) {
            $('.menu-category-title').hover(function () {
                $(this).addClass('active');
                var dataCategory = $(this).attr('data-category');
                $('.menu-category-item[data-category=' + dataCategory + ']').addClass('active')
                $('.menu-category-item[data-category=' + dataCategory + ']').siblings().removeClass('active')
                $(this).siblings().removeClass('active');
            })
            $('.menu-category-item').each(function () {
                if ($(this).children('.item').length > 4) {
                    $(this).addClass('grid')
                    //           console.log($(this).attr('data-category'), $(this).children('.item').length)
                }
            })

        }
        else {
            $('.menu-category-item').each(function () {
                if ($(this).children('.item').length > 4) {
                    $(this).addClass('grid')
                    //           console.log($(this).attr('data-category'), $(this).children('.item').length)
                }
            })
            $('.overlay-title').click(function () {
                $(this).parents('.menu-category-title').addClass('active');
                $(this).hide();
                var dataCategory = $(this).parents('.menu-category-title').attr('data-category');
                $('.menu-category-item[data-category=' + dataCategory + ']').addClass('active')
                $(this).parents('.category-item').siblings().find('.menu-category-item').removeClass('active')
                $(this).parents('.category-item').siblings().find('.menu-category-title').removeClass('active');
                $(this).parents('.category-item').siblings().find('.overlay-title').show()
            })
            if (count == 0) {
                //   $('.mobile-menu__content ul').prepend($('.mobile-menu__submenu .feature-shop'))
                //   var shopTitle = $('.mobile-menu__content .feature-shop .mega-menu__title').first().attr('shop-title');
                //   var menuTitle = $('.mobile-menu__content .feature-shop .mega-menu__title').first().attr('menu-title');
                //   $('.mobile-menu__content .feature-shop .mega-menu__title').first().text(menuTitle);
                //   count++;
            }
            $('.mobile-menu__content>ul>li').click(function () {
                $('.mobile-menu').addClass('open-sub');
                $('.mobile-menu__toggle-icon').addClass('open-sub');
                //   $('.mobile-menu__content .feature-shop .mega-menu__title').first().text(shopTitle);

            })
            setRightIcon()
            $('.mobile-menu__toggle-button').click(function () {
                if (countClick == 0) {
                    setTimeout(function () {
                        setRightIcon()
                    }, 400)
                    countClick++;
                }
                $('body').toggleClass('no-scroll')
            })

            $('.mobile-header__back-menu').click(function () {
                $('.mobile-menu').removeClass('open-sub');
                $('.mobile-menu__toggle-icon').removeClass('open-sub');
                $('.submenu__input').prop('checked', false);
                // $('.mobile-menu__content .feature-shop .mega-menu__title').first().text(menuTitle);
                $('.overlay-title').show();
                $('.mobile-menu .menu-category-title').removeClass('active');
                $('.mobile-menu .menu-category-item').removeClass('active');
            })

        }
    }

    function setRightIcon() {
        var menuW = $('.mobile-menu__content').width();
        var windowW = $(window).width();
        var spacing = 62;
        if (windowW > menuW) {
            spacing = spacing + windowW - menuW;
        }
        $('.mobile-menu__toggle-icon').css('--right', spacing + 'px')
    }

    $(window).on('resize', function () {
        menuHover()
    })

    var customReview = $('.custom-images-review')
        .on('init', function (slick) {
            $('.custom-images-review').fadeIn(1000);
            clrbx();
        })
        .slick({
            slidesToShow: 5,
            slidesToScroll: 5,
            lazyLoad: 'ondemand',
            autoplaySpeed: 3000,
            dots: false,
            centerPadding: '8px',
            infinite: true,
            prevArrow: '<button type="button" class="slick-prev"><</button>',
            nextArrow: '<button type="button" class="slick-next">></button>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
        });

    setTimeout(function () {
        $('.custom-images-review-container').insertAfter('.jdgm-rev-widg__title');
    }, 1000);

    $('.delivery-postcode-wrapper').clone().insertAfter('.inject-image-section');

    // custom-link-to-category
    var currentUrl = window.location.href;
    $('.custom-link-to-category a').each(function () {
        var categoryLink = $(this).attr('href');
        console.log(categoryLink);
        if (currentUrl.includes(categoryLink)) {
            $(this).addClass('active');
        }
    })
    if ($(window).width() > 767) {
        var swiperMenuList = new Swiper('.collections-menu-list', {
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 0,

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-menu-list-button-next',
                prevEl: '.swiper-menu-list-button-prev',
            },
        });
    }

    function stickyHeader() {
        var $header = $('#shopify-section-theme-header');
        var $topBar = $('#shopify-section-announcement-bar');
        var $mobileHeaderWrapper = $('.mobile-header-wrapper');
        var lastScrollTop = 0;
        var delta = 5;

        function setHeaderState() {
            var scrolled = $(window).scrollTop();
            var topBarHeight = $topBar.outerHeight() || 0;
            var mobileHeaderHeight = $mobileHeaderWrapper.outerHeight() || 0;
            var triggerPoint = mobileHeaderHeight;

            $header.toggleClass('is-sticky', scrolled >= topBarHeight);

            if (Math.abs(lastScrollTop - scrolled) <= delta)
                return;

            if (scrolled > lastScrollTop && scrolled > triggerPoint) {
                // Scrolling down & past the header height
                $('body').addClass('header-hidden');
            } else {
                // Scrolling up or not past header height yet
                $('body').removeClass('header-hidden');
            }

            lastScrollTop = scrolled;
        }

        $(window).on('scroll load', setHeaderState);
    }

    stickyHeader();
});

$(document).on('keyup keypress', '.postcode', function (e) {
    var $postcodeField = $(this);
    var postcode = $postcodeField.val();
    if (postcode) {
        postcode = parseInt(postcode.replace(/\D/g, ''));
        $('.delivery-postcode .icon-close').show();
    }
    else {
        $('.delivery-postcode .icon-close').hide();
    }

    var $notiItem = $postcodeField.closest('.delivery-postcode-wrapper').find('.noti-item');

    $notiItem.each(function () {
        var from = parseInt($(this).attr('data-from'));
        var to = parseInt($(this).attr('data-to'));

        if (!postcode) {
            $('.noti-item').hide();
            $('.not-value').show();
        } else if (postcode >= from && postcode <= to) {
            $(this).show();
            $(this).siblings().hide();
        } else {
            $('.not-value').show();
            $('.noti-item').hide();
        }
    })

    if (e.keyCode == 13) {
        e.preventDefault();
        return false;
    }
});

$(document).on('click', '.icon-close', function (e) {
    $(this).hide();
    $(this).closest('.delivery-postcode-wrapper').find('.postcode').val('');
    $(this).closest('.delivery-postcode-wrapper').find('.noti-item').hide();
    $(this).closest('.delivery-postcode-wrapper').find('.not-value').hide();
})

var cartInfo = function () {
    var tmp = null;
    $.ajax({
        async: false,
        type: "GET",
        cache: false,
        dataType: 'json',
        url: "/cart.js",
        success: function (data) {
            tmp = data;
        }
    });
    return tmp;
}();


function removeItemInCart(item, itemKey, upsellId) {
    var itemKeyUpsell = '';
    var data = { updates: {} };
    if (upsellId != '') {
        var items = cartInfo.items;
        for (var i = 0; i < items.length; i++) {
            if (upsellId == items[i].id && items[i].properties['_isupsell'] == '_isupsell') {
                itemKeyUpsell = items[i].key;
            }
        }
        data.updates[itemKey] = 0;
        data.updates[itemKeyUpsell] = 0;
    } else {
        data.updates[itemKey] = 0;
    }

    jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function () {
            location.reload();
        }
    });

    // if (upsellId != '')
    //   var idToProcess = variantId + ',' + upsellId;
    // else
    //   var idToProcess = variantId;
    // var itemsArray = idToProcess.split(',');

    // var qty = 0;
    // var data = { updates: {} };

    // for (i = 0; i < itemsArray.length; i++) {
    //   data.updates[itemsArray[i]] = qty;
    // }

    // console.log(typeof data)

    // jQuery.ajax({
    //   type: 'POST',
    //   url: '/cart/update.js',
    //   data: data,
    //   dataType: 'json',
    //   success: function () {
    //     location.reload();
    //   }
    // });
}

// function cloneFilterValues() {
//   //$('.delivery-postcode-wrapper').clone().insertAfter('.inject-image-section');
//   $('.cloud-search-filter-values-container').each(function () {
//     var filterName = $(this).data('filter-name');
//     var $filterValueBox = $(this);
//     $('.cloud-search-page-controls__filters .cloud-search-filter').each(function () {
//       if (filterName == $(this).data('filter-name')) {
//         $filterValueBox.appendTo($(this))
//       }
//     });
//   });
// }

// $(window).on("load", function () {
//   var checkExist = setInterval(function () {
//     if ($('.cloud-search-filter-values-container').length) {
//       console.log("Exists!");
//       clearInterval(checkExist);
//       cloneFilterValues(); //>> call function need to do when element is added to the site
//     }
//   }, 100); // check every 100ms
// });

(function initializeSwymNotification() {
    // Custom text to insert
    const customText = `
        <p class="swym-custom-pot-message" style="font-family: 'HelveticaNeue', Helvetica, Verdana, Arial, sans-serif; font-size: 10px; line-height: 1.4em; margin: 15px; color: #333;">
            <b>Did you add a pot to your plant?</b><br>
            Be sure to add the pot too so you don't forget it!
        </p>
    `;

    // Function to append custom text
    function appendCustomText(notification) {
        if (!notification) {
            console.warn('[Swym] No notification element provided');
            return false;
        }
        const detailsContainer = notification.querySelector('.swym-details-container, [class*="swym-details"]');
        if (detailsContainer) {
            if (!detailsContainer.querySelector('.swym-custom-pot-message')) {
                detailsContainer.insertAdjacentHTML('beforeend', customText);
                console.log('[Swym] Custom pot message added successfully');
                console.log('[Swym] Notification HTML:', notification.outerHTML);
                return true;
            } else {
                console.log('[Swym] Custom pot message already exists');
                return true;
            }
        } else {
            console.warn('[Swym] Details container not found');
            console.log('[Swym] Notification HTML:', notification.outerHTML);
            return false;
        }
    }

    // Function to check for notification with short polling
    function checkForNotification(source) {
        let pollCount = 0;
        const maxPolls = 10; // 5 seconds
        const pollInterval = 500;

        console.log(`[Swym] Checking for notification after ${source}`);

        const poll = setInterval(() => {
            pollCount++;
            const notification = document.querySelector('.swym-notifications-container, [class*="swym-notifications"]');
            if (notification) {
                console.log('[Swym] Notification found:', notification.className);
                if (appendCustomText(notification)) {
                    clearInterval(poll);
                }
            } else {
                console.log(`[Swym] Polling for notification (${pollCount}/${maxPolls})`);
                if (pollCount >= maxPolls) {
                    console.warn('[Swym] Notification not found after max polls');
                    console.log('[Swym] All Swym elements:', Array.from(document.querySelectorAll('[class*="swym"]')).map(el => el.outerHTML));
                    clearInterval(poll);
                }
            }
        }, pollInterval);
    }

    // Swym event listener for all events
    function setupSwymEventListener() {
        if (window.SwymCallbacks) {
            window.SwymCallbacks.push(swymCallbackFn);
        } else {
            window.SwymCallbacks = [swymCallbackFn];
        }

        function swymCallbackFn(swat) {
            if (swat && swat.evtLayer) {
                // Log all Swym events for debugging
                Object.values(swat.JSEvents).forEach(event => {
                    swat.evtLayer.addEventListener(event, (e) => {
                        if (event === swat.JSEvents.addedToCart) {
                            checkForNotification('addToCart event');
                        }
                    });
                });
            } else {

            }
        }
    }

    // Broad click listener for add-to-cart
    function setupClickListener() {
        document.addEventListener('click', (event) => {
            const button = event.target.closest('button, a, [type="submit"], [class*="add-to-cart"], [data-action], [data-swym-action]');
            if (button) {
                checkForNotification('potential add-to-cart click');
            }
        });
    }

    // Fallback DOM observer for Swym elements
    function setupDomObserver() {
        const observer = new MutationObserver((mutations) => {
            for (const mutation of mutations) {
                if (mutation.addedNodes.length) {
                    const notification = document.querySelector('.swym-notifications-container, [class*="swym-notifications"]');
                    if (notification) {
                        console.log('[Swym] Notification detected via DOM observer:', notification.className);
                        appendCustomText(notification);
                    }
                }
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    // Start initialization
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        waitForSwym();
    } else {
        document.addEventListener('DOMContentLoaded', waitForSwym);
    }

    // Reinitialize on AJAX cart updates
    document.addEventListener('cart:updated', () => {
        console.log('[Swym] Cart updated, checking for notification');
        checkForNotification('cart update');
    });
})();

var ProductUpsell = class extends HTMLElement {
    constructor() {
        super();
        this._isLoaded = false;
    }
    connectedCallback() {
        this._loadRecommendations();
    }
    async _loadRecommendations() {
        if (this._isLoaded) {
            return;
        }
        this._isLoaded = true;
        const intent = this.getAttribute("intent") || "related", url = `${Shopify.routes.root}recommendations/products.json?product_id=${this.getAttribute("product")}&limit=4&intent=${intent}`, response = await fetch(url, { priority: "low" });
        const data = await response.json();
        if (data && data.products && data.products.length > 0) {
            const product = data.products[0];
            const upsellContent = this.querySelector("[data-product-upsell-content");
            let productHtml = ''
            data.products.forEach((product) => {
                productHtml += `
                    <div class="product-upsell-single">
                        <div class="product-upsell-single__image">
                            <img src="${product.featured_image}" width="80" height="80" alt="${product.title}" loading="lazy" />
                        </div>
                        <div class="product-upsell-single__info">
                            <div class="product-upsell-title">${product.title}</div>
                            <div class="product-upsell-price">$${(product.price / 100).toFixed(2) }</div>
                        </div>
                        <a class="product-upsell-link" href="${product.url}">View</a>
                    </div>
                `;
            })

            upsellContent.innerHTML = productHtml

            var $slider = $('.product-upsell-content')
                .on('init', function (slick) {
                    // $('.product-upsell-content').fadeIn(1000);
                })
                .slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    lazyLoad: 'ondemand',
                    autoplaySpeed: 3000,
                    dots: false,
                    swipe: true
                });

            this.classList.remove("loading");
        } else {
            this.remove();
        }
    }
};

if (!window.customElements.get("product-upsell")) {
    window.customElements.define("product-upsell", ProductUpsell);
}
$(document).ready(function () {

    function stickyHeader() {
        var $header = $('#shopify-section-theme-header');
        var $topBar = $('#shopify-section-announcement-bar');
        var $mobileHeaderWrapper = $('.mobile-header-wrapper');
        var lastScrollTop = 0;
        var delta = 5;

        function setHeaderState() {
            var scrolled = $(window).scrollTop();
            var topBarHeight = $topBar.outerHeight() || 0;
            var mobileHeaderHeight = $mobileHeaderWrapper.outerHeight() || 0;
            var triggerPoint = mobileHeaderHeight;

            $header.toggleClass('is-sticky', scrolled >= topBarHeight);

            if (Math.abs(lastScrollTop - scrolled) <= delta)
                return;

            if (scrolled > lastScrollTop && scrolled > triggerPoint) {
                // Scrolling down & past the header height
                $('body').addClass('header-hidden');
            } else {
                // Scrolling up or not past header height yet
                $('body').removeClass('header-hidden');
            }

            lastScrollTop = scrolled;
        }

        $(window).on('scroll load', setHeaderState);
    }

    stickyHeader();
});

